import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { UserStateModel } from '@app/shared/store/user/user.state'
import { getEndpoint } from '@app/utils/get-endpoint'
import { firstValueFrom, map, tap } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class UserService {
	#userService: string = 'Users'
	#petService: string = 'Pets'

	constructor(private http: HttpClient) {}

	public async getUserDetails(): Promise<any> {
		try {
			return firstValueFrom(this.http.get('https://graph.microsoft.com/v1.0/me'))
		} catch (err) {
			return Promise.reject(err)
		}
	}

	public async getUserByEmail(email: string): Promise<UserStateModel> {
		return firstValueFrom(
			this.http
				.post<UserStateModel>(getEndpoint([this.#userService, 'GetUserByEmail']), { email })
				.pipe(map((res) => res))
		)
	}

	public async getBreedList(): Promise<any> {
		try {
			return firstValueFrom(this.http.get(getEndpoint([this.#petService, 'GetBreedList'])))
		} catch (err) {
			return Promise.reject(err)
		}
	}
}
